/**
 * Newsletter subscription form handler
 * Handles form submission and displays success/error messages
 */
export function initNewsletterForm() {
  const form = document.getElementById('subscriptionForm');
  if (!form) {
    return;
  }

  const emailInput = document.getElementById('property_email');
  const successMessage = document.getElementById('successMessage');
  const errorMessage = document.getElementById('errorMessage');
  const hiddenInput = form.querySelector('input[name="cfcfcfcfcf"]');

  if (!emailInput || !successMessage || !errorMessage) {
    return;
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    // Hide previous messages
    successMessage.style.display = 'none';
    errorMessage.style.display = 'none';

    const email = emailInput.value.trim();

    if (!email) {
      return;
    }

    const postData = {
      email: email,
      cfcfcfcfcf: hiddenInput ? hiddenInput.value : '',
    };

    try {
      const response = await fetch('https://uutiskirje.hakonen.fi/account/?ajax', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(postData).toString(),
      });

      const data = await response.json();

      if (data.success) {
        successMessage.innerHTML = `
          Kiitos tilauksestasi!
          <br>
          <br>
          Olet liittynyt sähköpostilistalle osoitteella <b>${email}</b>.<br>
          Jos haluat peruuttaa tilauksesi tulevaisuudessa, voit tehdä sen sähköpostiviestin lopussa olevaa linkkiä käyttämällä.
        `;
        successMessage.style.display = 'block';
        form.style.display = 'none';
      } else {
        errorMessage.innerHTML = `
          Valitettavasti jotain meni pieleen.
          <br>
          <br>
          Tarkista, että syöttämäsi sähköpostiosoite on oikein ja yritä uudelleen.
        `;
        errorMessage.style.display = 'block';
      }
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      errorMessage.innerHTML = `
        Valitettavasti jotain meni pieleen.
        <br>
        <br>
        Tarkista, että syöttämäsi sähköpostiosoite on oikein ja yritä uudelleen.
      `;
      errorMessage.style.display = 'block';
    }
  });
}
